import * as consts from 'consts/consts';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import Page from '../Layout/Pages/Page';
import FeatureAdministration from '../Organization/FeatureAdministration';
import { AdministrationTab } from './administrationTabs';
import OrganizationAudit, {
  AuditEntryType,
} from './PeopleAdministration/Audit/OrganizationAudit';

const FeaturesAdministrationPage: FC = () => {
  const { formatMessage } = useIntl();

  const tabs: AdministrationTab[] = [
    {
      path: consts.ADMINISTRATION_FEATURES(formatMessage).path,
      name: consts.ADMINISTRATION_FEATURES(formatMessage).name,
      content: <FeatureAdministration />,
    },
    {
      path: consts.ADMINISTRATION_FEATURES_AUDIT(formatMessage).path,
      name: consts.ADMINISTRATION_FEATURES_AUDIT(formatMessage).name,
      content: (
        <OrganizationAudit
          auditEntryTypes={[AuditEntryType.FEATURE_MANAGEMENT]}
        />
      ),
    },
  ];

  return (
    <Page
      title={consts.ADMINISTRATION_FEATURES(formatMessage).name}
      tabs={tabs}
    />
  );
};

export default React.memo(FeaturesAdministrationPage);
